// Chọn nguồn cho các ô telemetry của popup thông tin xe.
//
// Popup có hai nguồn: `positionsInfoBox` (đường WebSocket, tươi theo từng bản tin thiết bị) và
// `detailedVehicleInfo` (kết quả poll GET /vehicles/detail/:id, đứng im giữa hai lượt gọi). Với
// nhóm telemetry sống thì đường WebSocket phải thắng.
export const LIVE_WS_FIELDS = [
  'battery',
  'charge_status',
  'door_status',
  'engine_status',
  'gps_status',
  'gsm_level',
  'gsm_signal',
  'location',
  'memory_card',
  'satellites',
  'speed_digital_meter',
  'speed_gps'
];

// Trường mà giá trị 0 KHÔNG phải một số đo, chỉ là "thiết bị không báo".
//
// Dịch vụ realtime đang chạy trên production (nhánh `prod` của vgps_realtime_geo_service) gửi
// `data` dưới dạng struct Go CÓ KIỂU, không phải map. Trường thiết bị không báo vì thế được tuần
// tự hoá thành 0 chứ không vắng mặt — nên chỉ kiểm `!== undefined` là chưa đủ.
//
// Phía HTTP thì `vehicle.service.ts` trả `gsm_level: periodic.data?.[253] ?? null`, tức phân biệt
// được "chưa có". Nếu để 0 của WebSocket thắng null của HTTP thì ô Sóng hiện "0" thay vì "--", và
// người vận hành đọc thành "mất sóng".
//
// KHÔNG đưa vào đây những trường mà 0 là số đo thật: tốc độ 0 (xe đứng), động cơ 0 (tắt), sạc 0
// (không sạc), cửa 0 (đóng), GPS 0 (chưa định vị).
export const ZERO_MEANS_ABSENT = [
  'battery',
  'gsm_level',
  'gsm_signal',
  'satellites'
];

/**
 * Đường WebSocket có giá trị dùng được cho trường này không.
 *
 * Trả về false khi thiếu hẳn, khi rỗng, hoặc khi là 0 của một trường mà 0 vô nghĩa — để nơi gọi
 * rơi về nguồn HTTP như trước.
 */
export function hasLiveValue(positionsInfoBox, key) {
  if (!positionsInfoBox) return false;

  const value = positionsInfoBox[key];
  if (value === undefined || value === null || value === '') return false;
  if (value === 0 && ZERO_MEANS_ABSENT.includes(key)) return false;

  return true;
}

/** Lấy giá trị sống nếu dùng được, ngược lại trả về `fallback`. */
export function liveOr(positionsInfoBox, key, fallback) {
  return hasLiveValue(positionsInfoBox, key) ? positionsInfoBox[key] : fallback;
}
